module.exports = __webpack_public_path__ + "static/media/feed2.2a896b47.jpg";